// extracted by mini-css-extract-plugin
module.exports = {"progress":"HealthAndSafety_progress__2EKZZ","ring":"HealthAndSafety_ring__1fJNs","stroke":"HealthAndSafety_stroke__33qeC","navigation":"HealthAndSafety_navigation__1ZTCG"};